import React from 'react';
import PropTypes from 'prop-types';
import isNull from 'lodash/isNull';
import { createSwiper, SWIPER_CONTAINER_CLASS_NAME, SWIPER_WRAPPER_CLASS_NAME } from '../../utils/swiper';

export default class Carousel extends React.Component {
    constructor(props) {
        super(props);

        this.domEl = React.createRef();
        this.swiperContainerRef = React.createRef();
        this.swiperWrapperRef = React.createRef();
        this.swiper = null;
    }

    static propTypes = {
        children: PropTypes.node.isRequired,
        options: PropTypes.object,
        className: PropTypes.string,
        gtmAttribute: PropTypes.string,
        customNav: PropTypes.bool,
        isMobile: PropTypes.bool,
    };

    static defaultProps = {
        children: [],
        options: {},
        className: '',
        gtmAttribute: '',
        customNav: false,
        isMobile: false,
    };

    async initSwiper() {
        const {
            options,
            gtmAttribute,
            customNav,
            isMobile,
        } = this.props;
        const el = this.domEl.current;
        const containerEl = this.swiperContainerRef.current;
        const wrapperEl = this.swiperWrapperRef.current;

        if (!isNull(el) && el.hasChildNodes()) {
            if (!el.classList.contains('carousel-initialized')) {
                el.classList.add('carousel-initialized');
                this.swiper = await createSwiper(containerEl, wrapperEl, options, gtmAttribute, customNav);
            }

            if (this.swiper) {
                if (!isMobile) {
                    this.swiper.allowTouchMove = false;
                }

                this.swiper.update();
            }
        }
    }

    componentDidMount() {
        this.initSwiper();
    }

    componentDidUpdate() {
        this.initSwiper();
        if (this.swiper && !this.swiper.destroyed) {
            // for some reason on the racing page, we are losing reference to the navigation button.
            // this will make sure the navigation is initiated again when the page is updated.
            this.swiper.navigation.init();
            this.swiper.navigation.update();
        }
    }

    componentWillUnmount() {
        if (this.swiper) {
            this.swiper.destroy();
        }
    }

    render() {
        return (
            <div className={this.props.className} ref={this.domEl}>
                <div className={SWIPER_CONTAINER_CLASS_NAME} ref={this.swiperContainerRef}>
                    <div className={SWIPER_WRAPPER_CLASS_NAME} ref={this.swiperWrapperRef}>
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}
